// extracted by mini-css-extract-plugin
export default {"container":"incident_container__JT5I2","static":"incident_static__RigHp","staticContent":"incident_staticContent__b39MG"};